import { Helmet } from 'react-helmet'
import React from 'react'
import { Box, Button, Card, Container, Typography } from '@mui/material'
import useAppUtilities from '../../hooks/useAppUtilities'
import { ROUTES } from '../../helpers/routes-helper'

const BillingCancelPage: React.FC = () => {
  const { navigate } = useAppUtilities()

  const handleBackToPlans = (): void => {
    navigate(ROUTES.REDEEM_POINTS)
  }

  const handleGoHome = (): void => {
    navigate(ROUTES.HOME)
  }

  return (
    <Container component="main" sx={{ flex: 1, py: { xs: 4, md: 6 } }}>
      <Helmet><title>Resactly | Payment Canceled</title></Helmet>
      <Box sx={{ maxWidth: 600, mx: 'auto' }}>
        <Typography variant="h3" component="h1" color="text.primary" gutterBottom sx={{ mb: 3 }}>
          Checkout canceled
        </Typography>
        <Card
          sx={{
            p: 3,
            borderRadius: '16px',
            backgroundColor: 'background.paper',
          }}
        >
          <Typography variant="body1" color="text.primary" sx={{ mb: 2 }}>
            Your subscription checkout was canceled. Don&apos;t worry, you can start again
            whenever you&apos;re ready.
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            You can go back to the subscription plans to choose a tier, or return to the
            app home.
          </Typography>
          <Box display="flex" gap={2} flexDirection={{ xs: 'column', sm: 'row' }}>
            <Button
              variant="contained"
              fullWidth
              onClick={handleBackToPlans}
            >
              View Subscription Plans
            </Button>
            <Button
              variant="outlined"
              fullWidth
              onClick={handleGoHome}
            >
              Back to Home
            </Button>
          </Box>
        </Card>
      </Box>
    </Container>
  )
}

export default BillingCancelPage

